export default [
  'M34.972 4.974a2.898 2.898 0 0 1 3.92-.384 2.776 2.776 0 0 1 .412 4.053l-22.482 25.6a2.228 2.228 0 0 1-3.19.16L.892 22.533a2.775 2.775 0 0 1 0-4.075 2.9 2.9 0 0 1 3.937 0l10.066 9.378L34.972 4.974z',
];
